/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-danger */
import React, { FC, useEffect, useState } from 'react';
import i18n from 'i18next';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { animateScroll } from 'react-scroll';
import ModalidadForm from '../../Tarjetas/commons/ModalidadForm';
import CalculadoraForm from '../../Tarjetas/commons/CalculadoraForm';
import CambioCuentaForm from './form/CambioCuentaForm';
import useAPIError from '../../../hooks/useAPIError';
import { useAuthStore } from '../../../store/AuthContext';
import { useAppStore } from '../../../store/AppContext';
import tarjetaOro from '../../../assets/images/tarjeta-oro.png';
import { TarjetaService } from '../../../services';
import { CuotaPendienteType, InfoUsuarioOro } from '../../../types/Types';
import { PriceFormatter } from '../../../utils/PriceFormatter';
import { TarjetasOroConstants } from '../TarjetasOroConstants';
import SolicitarTarjetaOroForm from '../forms/SolictarTarjetaOroForm';
import BajaOroForm from './form/bajaOroForm';
import { StorageHelper } from '../../../utils/StorageHelper';
import ModalConfirmacion from '../../../components/ModalConfirmacion';
import { CookieHelper } from '../../../utils/CookieHelper';
// eslint-disable-next-line import/no-cycle
import SinTarjetaOro from '../SinTarjetaOro';
import { TarjetaOroHelper } from '../TarjetaOroHelper';
import { BackMappings } from '../../../utils/BackMappings';
import useSessionChecking from '../../../hooks/useSessionChecking';
import IconPencil from '../../../Icons/IconPencil';
import { WaEventsConstants } from '../wa-buttons/WaEventsConstants';
import { WaEventConponentFactory } from '../wa-buttons/WaEventConponentFactory';
import { CryptoUtil } from '../../../utils/CryptoUtil';

const TarjetaOroDatosEroski: FC = () => {
  const [goOn, setGoOn] = useState<boolean>(false);
  StorageHelper.setOrigin(BackMappings.ORO);
  useSessionChecking(BackMappings.ORO, setGoOn, goOn);

  const { t } = useTranslation();
  const waEventConponentFactory = new WaEventConponentFactory(t);

  const dataUser = useAuthStore();
  const { moneda } = dataUser.user;
  const dataApp = useAppStore();
  const { addError, addOro } = useAPIError();
  const [cuotasPendientes, setCuotasPendientes] = useState<
    CuotaPendienteType[]
  >([]);

  const [proximaCuota, setProximaCuota] = useState<string>();
  const [tieneImpagos, setTieneImpagos] = useState<boolean>(false);
  const [totalImpago, setTotalImpago] = useState<number>(0);
  const [showFormModalidad, setShowFormModalidad] = useState<boolean>(false);
  const [cuotaAltaSelected, setCuotaAltaSelected] = useState<boolean>(false);

  const [loadPendientes, setLoadPendientes] = useState<boolean>(false);
  const [loadInfo, setLoadInfo] = useState<boolean>(true);
  const [cardNumberLong, setCardNumberLong] = useState<string>();
  const [load, setLoad] = useState<boolean>(true);
  const [infoUsuarioOro, setInfoUsuarioOro] = useState<InfoUsuarioOro>();
  const [showFormCuentaBank, setShowFormCuentaBank] = useState<boolean>(false);
  const [showBajaForm, setShowBajaForm] = useState<boolean>(false);
  const [showFormCalculadora, setShowFormCalculadora] = useState<boolean>(
    false,
  );
  const [modalText, setModalText] = useState<string>('');
  const [showModal, setShowModal] = useState(false as boolean);
  const [reload, setReload] = useState<boolean>(false);
  const [formSolicitarVisible, setFormSolicitarVisible] = useState(false);
  const [errorFromMDM, setErrorFromMDM] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(false);
  const [firstCharge1, setFirstCharge1] = useState(true);
  const [firstCharge2, setFirstCharge2] = useState(true);
  const [firstCharge3, setFirstCharge3] = useState(true);
  const getCardNumber = () => {
    TarjetaService.getTarjeta()
      .then((response) => {
        if (response.data.error) {
          if (
            firstCharge1 &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          addOro(true);
          setLoad(false);
          setErrorFromMDM(true);
          StorageHelper.setErrorManageOro(
            true,
            TarjetaOroHelper.getErrorByResponse(response.data, t),
          );
        } else {
          setCardNumberLong(
            CryptoUtil.decryptAes(response.data.pojo.cardNumberLong),
          );
        }
        setFirstCharge1(false);
      })
      .catch((e) => {
        console.log(e);
        addOro(true);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  const formatProximaCuota = (fechaCuota: string) => {
    return moment(fechaCuota, 'DD/MM/YYYY')
      .locale(dataApp.lang)
      .format('MMMM YYYY');
  };

  const getInfoUsuarioOro = () => {
    TarjetaService.getInfoUsuarioOro()
      .then((response) => {
        if (response.data.error) {
          if (
            firstCharge2 &&
            response.data.errorCode !== BackMappings.GO_TO_RELOGIN
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          setLoadInfo(false);
          addOro(true);
          setErrorFromMDM(true);
          StorageHelper.setErrorManageOro(
            true,
            TarjetaOroHelper.getErrorByResponse(response.data, t),
          );
        } else {
          setInfoUsuarioOro(response.data.pojo);
          setLoadPendientes(response.data.pojo.showImpagos);
          setLoadInfo(false);
          if (StorageHelper.isThereTpvResponseMessage()) {
            const message = StorageHelper.getTpvResponseMessage() as string;
            StorageHelper.removeTpvResponseMessage();
            setModalText(message);
            setShowModal(true);
          }
        }
        setFirstCharge2(false);
      })
      .catch((e) => {
        console.log(e);
        addOro(true);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };
  const getInfoCuentaOro = () => {
    if (loadInfo && load) {
      getCardNumber();
      getInfoUsuarioOro();
      setReload(false);
    }
  };

  const getCuotasPendientesOro = () => {
    if (loadPendientes) {
      TarjetaService.getCuotasPendientesOro()
        .then((response) => {
          if (response.data.error) {
            if (
              firstCharge3 &&
              response.data.errorCode !== BackMappings.GO_TO_RELOGIN
            ) {
              addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
            }
            addOro(true);
            setErrorFromMDM(true);
            StorageHelper.setErrorManageOro(
              true,
              TarjetaOroHelper.getErrorByResponse(response.data, t),
            );
          } else {
            setLoadPendientes(false);
            setTotalImpago(response.data.totalImpago);
            setTieneImpagos(response.data.tieneImpagos);
            setCuotasPendientes(response.data.pojos);
            animateScroll.scrollTo(1120);
          }
          setFirstCharge3(false);
        })
        .catch((er: any) => {
          console.log(er);
          addOro(true);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
        });
    }
  };

  const solicitarBaja = () => {
    setShowBajaForm(true);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (dataUser.user.token !== '' && loadInfo) {
      getInfoCuentaOro();
      setLoadInfo(false);
    }
  });
  useEffect(() => {
    if (dataUser.user.token !== '') {
      setLoadInfo(true);
      getInfoCuentaOro();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  useEffect(() => {
    if (dataUser.user.token !== '' && reload) {
      setLoadInfo(true);
      getInfoCuentaOro();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  const priceFormatter = (value: any, conMoneda: boolean) => {
    const monedaText = moneda === 'euro' ? t('euro') : t('cc');
    return conMoneda
      ? PriceFormatter.formatStringAsPrice(value as string, monedaText)
      : PriceFormatter.formatStringAsPrice(value as string, '');
  };

  const calculadoraOnclick = () => {
    setShowFormCalculadora(true);
    document.body.classList.add('fix');
  };

  const abonarImpagos = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    const key = infoUsuarioOro?.estadoKey;
    if (key) {
      StorageHelper.setGoneToImpagos();
      StorageHelper.deleteUserFromSession();
      CookieHelper.removeUserCookies();
      document.location.href = `${process.env.REACT_APP_API}/${dataApp.lang}/abonar/impagos/${key}/`;
    }
  };

  const emptyMethod = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (dataUser.user.token !== '' && loadPendientes) {
      getCuotasPendientesOro();
      setLoadPendientes(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadPendientes]);

  useEffect(() => {
    if (errorFromMDM) {
      const errorManageOro = StorageHelper.getErrorManageOro();
      if (errorManageOro.error === 'true' && errorManageOro.message) {
        addOro(true);
        addError(errorManageOro.message, 'TARJETA-KO');
        StorageHelper.removeErrorManageOro();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorFromMDM]);

  if (goOn && !errorFromMDM) {
    if (!infoUsuarioOro?.isReactivar) {
      return (
        <>
          <section className="section header-tarjetas header-tarjetas__large tarjetas">
            <div className="container-inner">
              <div className="header-tarjetas__content">
                <h1 className="header-tarjetas__title">
                  {t('tarjetas.tarjeta-oro-datos.title')}
                </h1>
                <p>
                  {t('tarjetas.tarjeta-oro-datos.partner-number')}{' '}
                  <strong>{cardNumberLong}</strong>
                </p>
              </div>
            </div>
          </section>
          <section className="o-section u-padding-top-hero u-padding-bottom-hero section--background-img">
            <div className="container-inner">
              <div className="img-tarjeta img-tarjeta__oro">
                <img src="../assets/images/tarjeta-oro.png" alt="Tarjeta Oro" />
              </div>
              <div className="tarjeta__content tarjeta-oro__content">
                <h2 className="bloque-datos__title">
                  <span className="divider__square brand-gold-color" />
                  <span className="u-margin-right">
                    {t('tarjetas.tarjeta-oro-datos.data-card')}
                  </span>
                </h2>
              </div>

              {(() => {
                if (infoUsuarioOro?.isEmpresaOro && infoUsuarioOro?.empresa) {
                  return (
                    <div className="bloque-datos__datos u-margin-bottom-medium">
                      <h3 className="bloque-datos__name bloque-datos__titlntae">
                        <span className="u-margin-right">
                          {t('tarjetas.tarjeta-oro-datos.razon-social')}
                        </span>
                      </h3>
                      <p>{infoUsuarioOro?.empresa}</p>
                    </div>
                  );
                }
                return false;
              })()}
              <div className="bloque-datos">
                <div className="bloque-datos__datos u-margin-bottom-medium">
                  <h3 className="bloque-datos__name bloque-datos__title">
                    <span className="u-margin-right">
                      {t('tarjetas.tarjeta-oro-datos.actual-saving')}
                    </span>

                    {(() => {
                      if (
                        infoUsuarioOro?.showModificaTipoCuota &&
                        !infoUsuarioOro?.isEmpresaOro
                      ) {
                        return (
                          <a
                            className="bloque-datos__action modalidad"
                            onClick={() => {
                              setShowFormModalidad(true);
                              setCuotaAltaSelected(
                                infoUsuarioOro?.tipoCuota ===
                                  TarjetasOroConstants.TIPO_CUOTA_6,
                              );
                              document.body.classList.add('fix');
                            }}
                          >
                            <span className="icon__stroke icon-round icon-gold">
                              <IconPencil />
                            </span>
                          </a>
                        );
                      }
                      return false;
                    })()}
                  </h3>
                  <p>
                    {TarjetaOroHelper.getTipoCuotaAndValue(
                      infoUsuarioOro,
                      priceFormatter,
                      t,
                    )}
                  </p>
                </div>
                {(() => {
                  if (
                    !infoUsuarioOro?.isDatosIncompletos &&
                    infoUsuarioOro?.ibanFormatted &&
                    !infoUsuarioOro?.isEmpresaOro
                  ) {
                    return (
                      <div className="bloque-datos__datos u-margin-bottom-medium">
                        <h3 className="bloque-datos__name bloque-datos__title">
                          <span className="u-margin-right">
                            {t('tarjetas.tarjeta-oro-datos.bank-account')}
                          </span>
                          {(() => {
                            if (infoUsuarioOro?.showModificaCuenta) {
                              return (
                                <a
                                  className="bloque-datos__action edit-iban"
                                  onClick={() => {
                                    setShowFormCuentaBank(true);
                                    document.body.classList.add('fix');
                                  }}
                                >
                                  <span className="icon__stroke icon-round icon-gold">
                                    <IconPencil />
                                  </span>
                                </a>
                              );
                            }
                            return false;
                          })()}
                        </h3>
                        <p>{infoUsuarioOro?.ibanFormatted}</p>
                      </div>
                    );
                  }
                  return false;
                })()}
                {(() => {
                  if (infoUsuarioOro?.fechaAlta) {
                    return (
                      <div className="bloque-datos__datos u-margin-bottom-medium">
                        <h3 className="bloque-datos__name bloque-datos__title">
                          <span className="u-margin-right">
                            {t('tarjetas.tarjeta-oro-datos.out-date-card')}
                          </span>
                        </h3>
                        <p>{infoUsuarioOro?.fechaAlta}</p>
                      </div>
                    );
                  }
                  return false;
                })()}
                {(() => {
                  if (infoUsuarioOro?.fechaBaja) {
                    return (
                      <div className="bloque-datos__datos u-margin-bottom-medium">
                        <h3 className="bloque-datos__name bloque-datos__title">
                          <span className="u-margin-right">
                            {t('tarjetas.tarjeta-oro-datos.fecha-baja')}
                          </span>
                        </h3>
                        <p>{infoUsuarioOro?.fechaBaja}</p>
                      </div>
                    );
                  }
                  return false;
                })()}
                {(() => {
                  if (infoUsuarioOro?.fechaProximaCuota) {
                    return (
                      <div className="bloque-datos__datos u-margin-bottom-medium">
                        <h3 className="bloque-datos__name bloque-datos__title">
                          <span className="u-margin-right">
                            {t('tarjetas.tarjeta-oro-datos.next-fee')}
                          </span>
                        </h3>
                        <p className="capitalize">
                          {formatProximaCuota(
                            infoUsuarioOro?.fechaProximaCuota,
                          )}
                        </p>
                      </div>
                    );
                  }
                  return false;
                })()}
                {(() => {
                  if (infoUsuarioOro?.estado) {
                    return (
                      <div className="bloque-datos__datos u-margin-bottom-medium">
                        <h3 className="bloque-datos__name bloque-datos__title">
                          <span className="u-margin-right">
                            {t('tarjetas.tarjeta-oro-datos.state')}
                          </span>
                        </h3>
                        <p>{infoUsuarioOro?.estado}</p>
                      </div>
                    );
                  }
                  return false;
                })()}
                {(() => {
                  if (
                    infoUsuarioOro?.comentario &&
                    !infoUsuarioOro?.isReactivar &&
                    !infoUsuarioOro?.isEmpresaOro
                  ) {
                    return (
                      <div className="bloque-datos__datos u-margin-bottom-medium">
                        <h3 className="bloque-datos__name bloque-datos__titlntae">
                          <span className="u-margin-right">
                            {t('tarjetas.tarjeta-oro-datos.comentario')}
                          </span>
                        </h3>
                        {infoUsuarioOro?.comentario
                          ?.split('<br>')
                          .map((elem: string) => (
                            <p className="u-margin-bottom"> {elem} </p>
                          ))}
                      </div>
                    );
                  }
                  return false;
                })()}
                {(() => {
                  if (
                    infoUsuarioOro?.showSolicitarBaja &&
                    !infoUsuarioOro?.isEmpresaOro
                  ) {
                    return (
                      <div className="bloque-datos__datos u-margin-bottom-medium">
                        <h3 className="bloque-datos__name bloque-datos__title">
                          <span className="u-margin-right">
                            {t('tarjetas.tarjeta-oro-datos.want-out')}
                          </span>
                        </h3>
                        <p>
                          {(() => {
                            return waEventConponentFactory.getComponent(
                              WaEventsConstants.ORO_BAJA,
                              solicitarBaja,
                            );
                          })()}
                        </p>
                      </div>
                    );
                  }
                  return false;
                })()}
              </div>
              {(() => {
                if (
                  infoUsuarioOro?.showCalculadora &&
                  !infoUsuarioOro?.isEmpresaOro
                ) {
                  return (
                    <>
                      <div className="bloque-action__tarjeta-second bloque-action__second">
                        <div className="img img-tarjeta_small">
                          <img src={tarjetaOro} alt="Tarjeta Oro" />
                        </div>
                        <p className="bloque-action__title">
                          {t('tarjetas.tarjeta-oro-datos.change-fee')}
                        </p>
                        {(() => {
                          return waEventConponentFactory.getComponent(
                            WaEventsConstants.CALCULADORA,
                            calculadoraOnclick,
                          );
                        })()}
                      </div>
                    </>
                  );
                }
                return false;
              })()}
            </div>
          </section>
          {(() => {
            if (
              infoUsuarioOro?.showImpagos &&
              tieneImpagos &&
              !infoUsuarioOro?.isEmpresaOro
            ) {
              return (
                <section
                  className="o-section--large tarjetas"
                  id="scrollLoadId"
                >
                  <div className="container-inner">
                    <div className="tarjeta__content tarjeta-oro__content">
                      <h2 className="bloque-datos__title">
                        <span className="divider__square brand-gold-color" />
                        <span className="u-margin-right u-text-oro">
                          {t('tarjetas.tarjeta-oro-datos.pending-fee')}
                        </span>
                      </h2>
                    </div>
                    <div className="table-responsive u-margin-bottom-large">
                      <table className="table table--striped">
                        <thead>
                          <tr>
                            <th>
                              <span>
                                {t('tarjetas.tarjeta-oro-datos.concept')}
                              </span>
                            </th>
                            <th className="num">
                              {t('tarjetas.tarjeta-oro-datos.amount')}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {cuotasPendientes.map((c) => (
                            <tr>
                              <td>
                                <span>
                                  {t('tarjetas.tarjeta-oro-datos.recibo-cuota')}{' '}
                                  {c.mes}.{' '}
                                  <strong>
                                    {t(
                                      'tarjetas.tarjeta-oro-datos.pendiente-pago',
                                    )}
                                  </strong>
                                </span>
                              </td>
                              <td className="num">
                                <span>{priceFormatter(c.importe, false)}</span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td>
                              <span className="u-font-bold">
                                {t('tarjetas.tarjeta-oro-datos.total')}
                              </span>
                            </td>
                            <td className="num">
                              <span>{priceFormatter(totalImpago, false)}</span>
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>

                    <form method="post" className="u-margin-top-large">
                      <p className="u-text-right">
                        {(() => {
                          return waEventConponentFactory.getComponent(
                            WaEventsConstants.ORO_IMPAGOS,
                            abonarImpagos,
                          );
                        })()}
                      </p>
                    </form>
                  </div>
                </section>
              );
            }
            return false;
          })()}
          {(() => {
            if (infoUsuarioOro?.isDatosIncompletos) {
              return (
                <SolicitarTarjetaOroForm
                  visible
                  setVisible={emptyMethod}
                  isDatosIncompletos
                  setErrorMDM={setErrorFromMDM}
                />
              );
            }
            return false;
          })()}
          <ModalConfirmacion
            isBig={false}
            isOro
            isSmall={false}
            textCentered={false}
            showModal={showModal}
            setShowModal={setShowModal}
            title=""
            textHTMLContent={modalText}
            doAceptar={emptyMethod}
            doClose={emptyMethod}
            showCancel={false}
            acceptButtonTextKey={t('entendido')}
          />
          {/* Cambio modalidad */}
          <ModalidadForm
            visible={showFormModalidad}
            setVisible={setShowFormModalidad}
            cuotaAltaSelected={cuotaAltaSelected}
            setReload={setReload}
          />
          {/* calculadora */}
          <CalculadoraForm
            visible={showFormCalculadora}
            setVisible={setShowFormCalculadora}
          />
          {/* Cambio cuenta */}
          <CambioCuentaForm
            visible={showFormCuentaBank}
            setVisible={setShowFormCuentaBank}
            numCuentaFormatted={infoUsuarioOro?.ibanFormatted}
            iban={infoUsuarioOro?.iban}
            setReload={setReload}
          />{' '}
          <BajaOroForm
            visible={showBajaForm}
            setVisible={setShowBajaForm}
            setReload={setReload}
          />
          <SolicitarTarjetaOroForm
            visible={formSolicitarVisible}
            setVisible={setFormSolicitarVisible}
            isDatosIncompletos={false}
            setErrorMDM={setErrorFromMDM}
          />
        </>
      );
    }
    return <SinTarjetaOro />;
  }
  if (errorFromMDM) {
    return (
      <>
        <section className="section header-tarjetas header-tarjetas__large tarjetas">
          <div className="container-inner">
            <div className="header-tarjetas__content">
              <h1 className="header-tarjetas__title">
                {t('tarjetas.tarjeta-oro-datos.title')}
              </h1>
            </div>
          </div>
        </section>
        <section className="o-section u-padding-top-hero u-padding-bottom-hero section--background-img">
          <div className="container-inner">
            <div className="img-tarjeta img-tarjeta__oro">
              <img src="../assets/images/tarjeta-oro.png" alt="Tarjeta Oro" />
            </div>
          </div>
        </section>
      </>
    );
  }
  return <></>;
};

export default TarjetaOroDatosEroski;
